export default __webpack_public_path__ + "static/media/CA_profile.763eb348.svg";